// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2c70e127","453":"fb79880b","455":"9369693e"}[chunkId] + ".chunk.js";
};